/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { PaymentMethods } from '../types/utils';
import { UserID } from './user-model';

export type PaymentID = string;

export class Payment {
	id: PaymentID = ''

	BIC?: string

	IBAN?: string

	method: PaymentMethods = PaymentMethods.WIRE_TRANSFER

	name: string = ''

	userId: UserID = ''

	visible?: boolean
}